import React from 'react';
import moment from 'moment';

import {
    Card,
    Table,
    Tag,
    Modal
} from 'antd';

import {
    _postDataReportDownloads
} from '../../services'

import {
    ADMIN_URL
} from '../../index'

class DataReportHistory extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            limit: 20,
            dataReportDownloads: [],
            count: 1
        }
    }

    render() {

        return (
            <Card>
                {this.renderTable()}
            </Card>
        )
    }

    componentDidMount() {
        this.getReportDownloads()
    }

    renderTable = () => {

        const {page, limit, dataReportDownloads, count} = this.state
        const columns = [{
            title: 'Date Downloaded',
            dataIndex: 'dateCreated',
            render: (dateCreated) => moment(dateCreated).format('LLL')
        },{
            title: 'Report Name',
            dataIndex: 'reportName',
            // render: (reportName, record) => <a target='_blank' href={`${ADMIN_URL}/data-reports/${record.reportId}`}>{reportName}</a>
        },{
            title: 'Status',
            dataIndex: 'status',
            render: (status) => this.renderTag(status)
        },{
            title: 'Link',
            dataIndex: 'link',
            render: (link, record) => record.status=='COMPLETED' ? <a target='_blank' href={link}>Download</a> : ''
        },{
            title: 'Error Message',
            dataIndex: 'errorMsg',
        render: (errorMsg) => errorMsg ? <a href='#' onClick={() => this.renderErrorShow(errorMsg)}>Show Error</a> : ''
        }]

        return (
            <Table
                pagination={{
                    current: page,
                    pageSize: limit,
                    total: count,
                    onChange: (nextPage) => this.setState({ page: nextPage }, this.getReportDownloads)
                }}
                // onChange={this.handleTableChange}
                columns={columns}
                dataSource={dataReportDownloads}
                rowKey="_id"
                size="medium"
            />
        )
    }

    renderTag = (status) => {
        let color;
        switch (status) {
            case 'WAITING':
                color = 'blue';
                break;
            case 'RUNNING':
                color = 'orange';
                break;
            case 'COMPLETED':
                color = 'green';
                break;
            case 'ERROR':
                color = 'red';
                break;
            default:
                color = 'blue'
        }

        return <Tag color={color}>{status}</Tag>
    }

    renderErrorShow = (errorMsg) => {
        return (
            Modal.error({
                centered: true,
                title: "Error Message",
                content: errorMsg
            })
        )
    }

    getReportDownloads = () => {

        const {page, limit} = this.state

        _postDataReportDownloads({page, limit})
        .then(_dataReportDownloads => {
            this.setState({
                dataReportDownloads: _dataReportDownloads.data.dataReportDownloads.docs,
                count: _dataReportDownloads.data.dataReportDownloads.count
            })
        })
    }
}

export default DataReportHistory


// WEBPACK FOOTER //
// ./src/components/data-report-history/index.js